<template>
  <div>
    <component :is="component(slice.slice_type)" v-for="(slice, index) in slices" :key="`${slice.slice_type}-${index}`" :slice="slice" />
  </div>
</template>

<script>
import { Hero, FaqSlice, SimpleCta } from '@@/shared-slices'

import { QuinconceSlice } from '~/components/slices'

import { Partnership, PartnersCarousel, PartnersQuoteCarousel, PartnersTools } from './components'

const SLICE_COMPONENTS = {
  hero: 'Hero',
  partner_reasons: 'Partnership',
  partners_carousel: 'PartnersCarousel',
  partners_quote_carousel: 'PartnersQuoteCarousel',
  partners_tools: 'PartnersTools',
  quinconce_block: 'QuinconceSlice',
  faq_slice: 'FaqSlice',
  simple_cta: 'SimpleCta',
}

export default {
  name: 'Partners',
  components: {
    Hero,
    Partnership,
    PartnersCarousel,
    PartnersQuoteCarousel,
    PartnersTools,
    SimpleCta,
    QuinconceSlice,
    FaqSlice,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    slices() {
      return this.data.body
    },
    component() {
      return (sliceType) => SLICE_COMPONENTS[sliceType]
    },
  },
}
</script>

<style module lang="scss"></style>
